// extracted by mini-css-extract-plugin
export default {"iconLink":"IconLink_iconLink__AwJxR"};